import _ from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useMount from '../../../../../common/hooks/useMount';
import { CompanyModel } from '../../../models/Company';
import { resources } from '../../../resources/resources';
import { companyService } from '../../../services/company';
import CompanyCard from './Components/CompanyCard';

export default function CompaniesSettingsPage() {
  const { t: translate } = useTranslation();
  const [companies, setCompanies] = useState<CompanyModel[]>();

  const loadCompaniesForCustomer = async (
    abortController?: AbortController,
  ) => {
    const r = await companyService.getCompaniesByClient('', {
      signal: abortController?.signal,
    });

    if (!r.hasErrors) {
      setCompanies(r.data);
    }
  };

  useMount(() => {
    loadCompaniesForCustomer();
  });

  return (
    <>
      <div className="company-settings-title">
        <h1>{translate(resources.admin.companies.title)}</h1>
      </div>

      {_.map(companies, (company, index) => {
        return <CompanyCard key={index} company={company} />;
      })}
    </>
  );
}
